import ModalComponent from '..'
import { OrderChannelMap, OrderStatusMap } from '../../../constants'
import {
  CreatorTypeFilter,
  OrderChannelStatus,
  OrderQueryProps,
  OrderStatus,
} from '../../../redux-toolkits/orders/orders.type'
import { Accordion } from '../../accordion'
import { Button } from '../../button'
import { Checkbox } from '../../inputs/Checkbox'
import { SelectCreators } from './selectCreatorModal'

const CreatorTypeFilterMap: Record<
  CreatorTypeFilter | 'all',
  {
    text: string
  }
> = {
  all: {
    text: 'All creators',
  },
  onsite: {
    text: 'Onsite creators',
  },
  offsite: {
    text: 'Offsite creators',
  },
}

export const FilterOrdersModal = ({
  modalOpen,
  handleModalClose,
  setModalOpen,
  query,
  onSucess,
}: {
  modalOpen: boolean
  handleModalClose: () => void
  setModalOpen: (open: boolean) => void
  query?: OrderQueryProps
  onSucess: (query: OrderQueryProps) => void
}) => {
  return (
    <ModalComponent
      open={modalOpen}
      setOpen={setModalOpen}
      onCloseCallback={() => {
        handleModalClose()
      }}
      title={undefined}
      position="right"
    >
      <Button
        label="Reset filters"
        onClick={() => {
          onSucess({
            ...query,
            page: 1,
            channel: undefined,
            status: undefined,
            vendorId: undefined,
            creatorType: undefined,
          })
        }}
        primary={false}
        variant="plain"
        className="!px-0 !py-0 mb-10"
      />

      <Accordion title="Channel" className="pb-4 border-b" open={true}>
        <div className="flex flex-col gap-2 w-full">
          {Object.keys(OrderChannelMap).map((k) => {
            return (
              <Checkbox
                checkStatus={
                  !query?.channel && k === 'all' ? true : query?.channel === k
                }
                disabled={false}
                handleChange={() => {
                  onSucess({
                    ...query,
                    page: 1,
                    channel:
                      k === 'all' ? undefined : (k as OrderChannelStatus),
                  })
                }}
                text={OrderChannelMap[k as OrderChannelStatus].text}
                textPosition="left"
                className="w-full !justify-between !font-normal"
                key={k}
              />
            )
          })}
        </div>
      </Accordion>

      <Accordion title="Order Status" className="py-4 border-b" open={true}>
        <div className="flex flex-col gap-2 w-full max-h-[250px] overflow-y-scroll">
          {Object.keys(OrderStatusMap)
            .filter((k) => !['OPEN'].includes(k))
            .map((k) => {
              return (
                <Checkbox
                  checkStatus={
                    !query?.status && k === 'all' ? true : query?.status === k
                  }
                  disabled={false}
                  handleChange={() => {
                    onSucess({
                      ...query,
                      page: 1,
                      status: k === 'all' ? undefined : (k as OrderStatus),
                    })
                  }}
                  text={OrderStatusMap[k as OrderStatus].text}
                  textPosition="left"
                  className="w-full !justify-between !font-normal"
                  key={k}
                />
              )
            })}
        </div>
      </Accordion>

      <Accordion title="Creator Type" className="py-4 border-b" open={true}>
        <div className="flex flex-col gap-2 w-full">
          {Object.keys(CreatorTypeFilterMap).map((k) => {
            return (
              <Checkbox
                checkStatus={
                  !query?.creatorType && k === 'all'
                    ? true
                    : query?.creatorType === k
                }
                disabled={false}
                handleChange={() => {
                  onSucess({
                    ...query,
                    page: 1,
                    creatorType:
                      k === 'all' ? undefined : (k as CreatorTypeFilter),
                  })
                }}
                text={CreatorTypeFilterMap[k as CreatorTypeFilter].text}
                textPosition="left"
                className="w-full !justify-between !font-normal"
                key={k}
              />
            )
          })}
        </div>
      </Accordion>

      <Accordion title="Creator" className="py-4 border-b-0" open={true}>
        <p className="text-sec-black text-sm mb-6">
          {query?.vendorId?.split(',')?.length ?? 0} active{' '}
          {(query?.vendorId?.split(',')?.length ?? 0) === 1
            ? 'filter'
            : 'filters'}
        </p>
        <SelectCreators
          maxSelection={undefined}
          open={true}
          creators={
            query?.vendorId?.split(',')?.map((id) => {
              return {
                _id: id,
                banner: '',
                extendedBio: '',
                logo: '',
                name: '',
                slug: '',
                vendorId: id,
              }
            }) ?? []
          }
          setCreators={(c) => {
            onSucess({
              ...query,
              page: 1,
              vendorId: c.map((c) => c._id).join(','),
            })
          }}
        />
      </Accordion>
    </ModalComponent>
  )
}
